import {Shapes} from './Shapes';
export default Shapes;